import { Component, OnInit } from '@angular/core';
import {
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { Store } from '@ngrx/store';
import { ToastrService } from 'ngx-toastr';
import { SignupService } from 'src/app/services/signup.service';
import { WatcherService } from 'src/app/services/watcher.service';
import { AppState } from 'src/app/store/app.reducer';
@Component({
  selector: 'app-shipper-network',
  templateUrl: './shipper-network.component.html',
  styleUrls: ['./shipper-network.component.css'],
})
export class ShipperNetworkComponent implements OnInit {
  userId;
  token;
  profileDetails;
  searchCountryName;
  countries;
  phoneCodeCountrySelection = false;
  phoneSelectedCountry;
  phoneSelectedCountryCode;
  phoneSelectedCountryFlag;
  constructor(
    private toastr: ToastrService,
    private signUpService: SignupService,
    private watcherService: WatcherService,
    private store: Store<AppState>
  ) {
    this.store.select('auth').subscribe((state) => {
      this.token = state.token;
      this.userId = state.user?.id;
      this.profileDetails = state.user;
    });
    this.signUpService.getAllCountries().subscribe((countries) => {
      this.countries = countries['data'];
      if (this.profileDetails) {
        this.phoneSelectedCountry = this.countries.find((country) => {
          if (this.profileDetails?.phone.country_code.includes('+')) {
            return (
              country.country_phone_code ===
              this.profileDetails?.phone.country_code.slice(1)
            );
          } else {
            return (
              country.country_phone_code ===
              this.profileDetails?.phone.country_code
            );
          }
        });
        this.phoneSelectedCountryCode =
          this.phoneSelectedCountry.country_phone_code;
        this.phoneSelectedCountryFlag = this.phoneSelectedCountry.country_flag;
      } else {
        this.phoneSelectedCountry = this.countries[0];
        this.phoneSelectedCountryCode =
          this.phoneSelectedCountry.country_phone_code;
        this.phoneSelectedCountryFlag = this.phoneSelectedCountry.country_flag;
      }
    }); 
    if(this.userId && this.token){
      this.signUpService.getUserByUserID(this.userId, this.token).subscribe({
        next: (data) => {
          if (data['data']) {
            this.profileDetails = data['data'];
            this.form.patchValue({
              phoneCountryCode: this.profileDetails.phone['country_code'].replace(
                '+',
                ''
              ),
              phoneNumber: this.profileDetails.phone['phone_number'],
              email: this.profileDetails.email,
            });
          }
        },
        error: (err) => {
        },
      });
    }
    
  }
  form = new UntypedFormGroup({
    companyName: new UntypedFormControl('', [
      Validators.required,
      Validators.minLength(2),
    ]),
    phoneNumber: new UntypedFormControl('', [
      Validators.required,
      Validators.min(1000),
      Validators.max(999999999999),
    ]),
    email: new UntypedFormControl('', [
      Validators.required,
      Validators.email,
      Validators.minLength(4),
    ]),
  });

  firstSelection = 0;
  secondSelection = 0;
  thirdSelection = 0;
  lang;
  ngOnInit(): void {
    this.watcherService.getLang().subscribe((lang) => {
      this.lang = lang;
    });
  }
  onSubmit(form: UntypedFormGroup) {
    const payload = {
      shipping_services: Number(this.firstSelection),
      type_of_services: Number(this.secondSelection),
      extra_services: Number(this.thirdSelection),
      company_name: form.value.companyName,
      phone_number: {
        country_code: `+${this.phoneSelectedCountryCode}`,
        phone_number: `${form.value.phoneNumber}`,
      },
      email: form.value.email,
    };
    this.signUpService.postShipperNetwokr(payload).subscribe({
      next: (data: any) => {
        if (data.result.status === 200 || data.result.status === '200') {
          this.toastr.success(
            'Thank you for filling out the form. Our team will contact you as soon as possible.',
            'Success'
          );
          this.firstSelection = 0;
          this.secondSelection = 0;
          this.thirdSelection = 0;
          this.form.reset();
        } else {
        }
      }, 
      error: err => {
      }
    });
  }

  selectPhoneCountry(country) {
    this.phoneSelectedCountry = country;
    this.phoneSelectedCountryFlag = country.country_flag;
    this.phoneSelectedCountryCode = country.country_phone_code;
    this.phoneCodeCountrySelection = false;
  }
}
